import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { toggleStyle, menuStyle } from "../../data/dropdownStyles";


function ShadowPuppetOptions(props) {

  const dirPath = "/VisuallyDirectedFineMotor/AnimalShapes/"

  return (
    <div style={{ display: "flex", gap: "1rem" }}>
      <Dropdown style={{ display: props.FlashRateDisplay }}>
         <Dropdown.Toggle
          style={toggleStyle}
          variant="success"
          id="dropdown-basic"
        >
          Progression
        </Dropdown.Toggle>

        <Dropdown.Menu style={menuStyle}>
        {props.level.map((lvl) => (
          <Dropdown.Item
            key={lvl}
            onClick={() => {
              props.changeImage(lvl);
            }}
            active={props.levelBool === lvl}
          >
            {lvl}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
      </Dropdown>
      </div>
  );
}


export default function ShadowPuppets(props) {
  var [time, setTime] = useState(1000);
  var [image, setImage] = useState(props.defaultImage);
  var [dirPath, setDirPath] = useState("/VisuallyDirectedFineMotor/ShadowPuppets/");

  const [display, setDisplay] = useState(0);
  const [next, setNext] = useState(false);
  const [place, setPlace] = useState(0)


  function preLoadImages() {
    loadLevel(props.levelLabel,props.level)
  }

  function loadLevel(level, levelList) {
    for (let i = 0; i < levelList.Length; i++) {
      const animal = levelList[i]
      const img = new Image();
      img.src =
        dirPath + level + "/" + animal + ".png";
    }
  }

  useEffect(() => {
    preLoadImages();
  }, []);

  useEffect(() => {
    setDisplay(1);
    setNext(false);
    // setPlace(0);
    
  }, [props.open]);

  function displayPicture(place) {
      //console.log("this is the place: ", place)
      setPlace((place+1)%props.level.length)
      setImage(props.level[place])
      //console.log(dirPath + props.levelLabel + '/' + image + '.png')
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div className="activitySettingsButtonsContainer">
        <ShadowPuppetOptions
          level={props.level}
          flashRate={setTime}
          flashBool={time}
          changeLevel={props.setLevel}
          levelBool={props.level}
          hiddenLetter={setDirPath}
          letterBool={dirPath}
          hiddenLetterDisplay="none"
          levelDisplay="none"
          changeImage={setImage}
          imageBool={image}
          changePdf={props.changePdf}
          setPlace={setPlace}
        />
      </div>
      {props.open && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "90%",
          }}
        >
          {display === 1 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "column",
                height: "100%",
                width: "100%",
              }}
            >
              <img
                style={{height: '100%'}}
                src={dirPath + props.levelLabel + '/' + image + '.png'}//{dirPath + "/" + level + "/" + image + ".png"}
              />
            </div>
          )}
        </div>
      )}
      <div className="activityActionButtonsContainer">
        <button
          className="activityActionButton"
          onClick={() => {
            if (props.open) {
              displayPicture(place);
            } else {
              props.openActivity(true);
            }
          }}
          // disabled={next}
        >
          Next
        </button>
      </div>
    </div>
  );
}
